import { lazy } from "react";
import { RouteObject } from "react-router-dom";
const AuthLayout = lazy(() => import("../layouts/AuthLayout"));
const PharmacyLayout = lazy(() => import("../layouts/PharmacyLayout"));
const AccountType = lazy(() => import("../pages/Auth-Pages/AccountType"));
const ChosenFacility = lazy(() => import("../pages/Auth-Pages/ChosenFacility"));
const CreatePassword = lazy(() => import("../pages/Auth-Pages/CreatePassword"));
const NewNumber = lazy(() => import("../pages/Auth-Pages/NewNumber"));
const Profile = lazy(() => import("../pages/Auth-Pages/Profile"));
const VerifyOtp = lazy(() => import("../pages/Auth-Pages/VerifyOtp"));
const Cart = lazy(() => import("../pages/Cart/Cart"));
const SharedCart = lazy(() => import("../pages/Cart/SharedCart"));
const DrugCardDetails = lazy(() => import("../pages/Drugs/DrugDetails"));
const ErrorPage = lazy(() => import("../pages/ErrorPages/ErrorPage"));
const InternalServerErrorPage = lazy(
  () => import("../pages/ErrorPages/InternalServerErrorPage"),
);
const Home = lazy(() => import("../pages/Home/Pharmacy/PharmacyHomeV2"));
const Notifications = lazy(
  () => import("../pages/Notifications/Notifications"),
);
const List = lazy(() => import("../pages/Offers/Pharmacy/List"));
const OfferDetails = lazy(
  () => import("../pages/Offers/Pharmacy/OfferDetails"),
);
const WarehouseOfferDetails = lazy(
  () => import("../pages/Warehouses/WarehouseOfferDetails"),
);
const PharmacyOrdersList = lazy(() => import("../pages/Orders/Pharmacy/List"));
const NewOrder = lazy(() => import("../pages/Orders/Pharmacy/NewOrder"));
const PharmacyOrderDetails = lazy(
  () => import("../pages/Orders/Pharmacy/OrderDetails"),
);
const ProductDetails = lazy(
  () => import("../pages/Products/Pharmacy/ProductDetails"),
);
const ProductsCards = lazy(() => import("../pages/Products/Warehouse/Cards"));
const ProductsList = lazy(() => import("../pages/Products/Warehouse/List"));
const NewProduct = lazy(() => import("../pages/Products/Warehouse/NewProduct"));
const AvailableInWarehousesDrugs = lazy(
  () => import("../pages/Search/AvailableInWarehousesDrugs"),
);

const BestOfOffers = lazy(() => import("../pages/Search/BestOfOffers"));
const DrugAlternativesDrugs = lazy(
  () => import("../pages/Search/DrugAlternativesDrugs"),
);
const Search = lazy(() => import("../pages/Search/Search"));
const HelpCenter = lazy(() => import("../pages/Settings/HelpCenter"));
const NotificationsSettings = lazy(
  () => import("../pages/Settings/NotificationsSettings"),
);
const PrivacyPolicy = lazy(() => import("../pages/Settings/PrivacyPolicy"));
const TermsAndConditions = lazy(
  () => import("../pages/Settings/TermsAndConditions"),
);
const PharmacyStaffList = lazy(() => import("../pages/Staff/Pharmacy/List"));
const WarehouseDetails = lazy(
  () => import("../pages/Warehouses/WarehouseDetails"),
);
const Warehouses = lazy(() => import("../pages/Warehouses/Warehouses"));
const ISVerifiedGuard = lazy(() => import("./ISVerifiedGuard"));
const ForgetPassword = lazy(() => import("../pages/Auth-Pages/ForgetPassword"));
const PatientOrderDetails = lazy(
  () => import("../pages/Orders/Pharmacy/PatientOrderDetails"),
);
const PointsList = lazy(() => import("../pages/points/pharmacy/List"));
const PointsDetails = lazy(() => import("../pages/points/pharmacy/PointsDetails"));

const ReturnOrder = lazy(() => import("../pages/Orders/Pharmacy/ReturnOrder"));
export const pharmacyRoutes: RouteObject[] = [
  {
    path: "",
    index: true,
    element: (
      <PharmacyLayout>
        <Home />
      </PharmacyLayout>
    ),
  },
  {
    path: "profile",
    element: (
      <PharmacyLayout>
        <Profile />
      </PharmacyLayout>
    ),
  },
  //?========================Settings Routes========================
  {
    path: "settings/help-center",
    element: (
      <PharmacyLayout>
        <HelpCenter />
      </PharmacyLayout>
    ),
  },
  {
    path: "settings/terms-and-conditions",
    element: (
      <PharmacyLayout>
        <TermsAndConditions />
      </PharmacyLayout>
    ),
  },
  {
    path: "settings/privacy-policy",
    element: (
      <PharmacyLayout>
        <PrivacyPolicy />
      </PharmacyLayout>
    ),
  },
  {
    path: "settings/notifications-center",
    element: (
      <PharmacyLayout>
        <NotificationsSettings />
      </PharmacyLayout>
    ),
  },

  //?========================Product Routes========================
  {
    path: "products/list",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <ProductsList />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  {
    path: "products/cards",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <ProductsCards />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  {
    path: "products/new-product",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <NewProduct />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },

  //?========================Orders Routes========================
  {
    path: "orders",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <PharmacyOrdersList />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  {
    path: "orders/new-order",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <NewOrder />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  {
    path: "orders/new-order/:id/offers/:id",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <OfferDetails />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  {
    path: "orders/:id",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <PharmacyOrderDetails />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  {
    path: "orders/patient-order/:id",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <PatientOrderDetails />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  {
    path: "orders/return-order",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <ReturnOrder />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  //?========================Offers Routes========================
  {
    path: "offers",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <List />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  {
    path: "offers/:id",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <OfferDetails />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  //?========================Admins Routes========================
  {
    path: "admins",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <Home />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  //?========================Staff Routes========================
  {
    path: "staff",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <PharmacyStaffList />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },

  //?========================Notifications Routes========================
  {
    path: "notifications",
    element: (
      <PharmacyLayout>
        <Notifications />
      </PharmacyLayout>
    ),
  },
  //?========================Search Routes========================
  {
    path: "search",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <Search />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  //?========================Drug Card Details Routes========================
  {
    path: "/drugs/drug-details/:id",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <DrugCardDetails />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  //?========================Product Card Details Routes========================
  {
    path: "/products/product-details/:id",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <ProductDetails />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  //?========================Cart Routes========================
  {
    path: "cart",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <Cart />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  {
    path: "shared-cart/:id",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <SharedCart />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  //?========================Warehouses Routes========================
  {
    path: "warehouses",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <Warehouses />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  {
    path: "warehouses/:id",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <WarehouseDetails />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  {
    path: "warehouses/:id/offers/:id",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <WarehouseOfferDetails />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  //?========================Drugs Available in Warehouses Routes========================
  {
    path: "drugs/drug-details/:id/available-in",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <AvailableInWarehousesDrugs />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  //?========================Drugs Best Of Offers Routes========================
  {
    path: "drugs/drug-details/:id/best-of-offers",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <BestOfOffers />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  //?========================Drugs Alternatives Routes========================
  {
    path: "drugs/drug-details/:id/alternative-drugs",
    element: (
      <PharmacyLayout>
        <ISVerifiedGuard>
          <DrugAlternativesDrugs />
        </ISVerifiedGuard>
      </PharmacyLayout>
    ),
  },
  // {
  //   path: "points",
  //   element: (
  //     <PharmacyLayout>
  //       <ISVerifiedGuard>
  //         <PointsList />
  //       </ISVerifiedGuard>
  //     </PharmacyLayout>
  //   ),
  // },
  // {
  //   path: "points/:id",
  //   element: (
  //     <PharmacyLayout>
  //       <ISVerifiedGuard>
  //         <PointsDetails />
  //       </ISVerifiedGuard>
  //     </PharmacyLayout>
  //   ),
  // },
  //?========================= Security Routes========================
  //?========================= Security Routes========================
  //?========================= Security Routes========================
  //?========================= Security Routes========================
  //?========================= Security Routes========================
  //?========================= Security Routes========================
  //?========================= Security Routes========================
  //?========================= Security Routes========================
  {
    path: "account/forget-password",
    element: (
      <AuthLayout>
        <ForgetPassword OriginType="account" />
      </AuthLayout>
    ),
  },
  {
    path: "account/forget-password/otp",
    element: (
      <AuthLayout>
        <VerifyOtp OriginType="account" />
      </AuthLayout>
    ),
  },
  {
    path: "account/forget-password/create-password",
    element: (
      <AuthLayout>
        <CreatePassword OriginType="account" />
      </AuthLayout>
    ),
  },
  {
    path: "account/update-password",
    element: (
      <AuthLayout>
        <CreatePassword OriginType="account" />
      </AuthLayout>
    ),
  },
  {
    path: "account/new-number",
    element: (
      <AuthLayout>
        <NewNumber OriginType="account" />
      </AuthLayout>
    ),
  },
  {
    path: "account/new-number/otp",
    element: (
      <AuthLayout>
        <VerifyOtp OriginType="account" />
      </AuthLayout>
    ),
  },
  {
    path: "account/new-account",
    element: (
      <AuthLayout>
        <AccountType OriginType="account" />
      </AuthLayout>
    ),
  },
  {
    path: "account/account-facility-type",
    element: (
      <AuthLayout>
        <ChosenFacility OriginType="account" />
      </AuthLayout>
    ),
  },

  //?==========================ERRORPAGE========================
  {
    path: "*",
    element: <ErrorPage />,
  },
  {
    path: "500",
    element: <InternalServerErrorPage />,
  },
];
